import React, { useState } from 'react';
import { useNavigate, Navigate } from 'react-router-dom';
import { Loader2, Lock } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { toast } from 'sonner';
import api from '@/lib/api';
import { useAuth } from '@/lib/auth';

export default function ChangePassword() {
  const { user, refresh } = useAuth();
  const nav = useNavigate();
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [loading, setLoading] = useState(false);

  if (!user) return <Navigate to="/admin/login" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (next.length < 8) {
      toast.error('A nova senha deve ter pelo menos 8 caracteres.');
      return;
    }
    if (next !== confirm) {
      toast.error('As senhas não coincidem.');
      return;
    }
    setLoading(true);
    try {
      await api.post('/auth/change-password', { current_password: current, new_password: next });
      toast.success('Senha alterada com sucesso!');
      await refresh();
      nav('/admin/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.detail || 'Erro ao alterar senha');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <Card className="border border-border bg-card">
          <CardContent className="p-6">
            <div className="flex items-center gap-2 text-white">
              <Lock className="w-4 h-4 text-[var(--g66-amber)]" />
              <div className="font-semibold">Trocar senha</div>
            </div>
            <p className="text-xs text-muted-foreground mt-1">Por segurança, defina uma nova senha antes de continuar.</p>
            <form onSubmit={handleSubmit} className="mt-5 space-y-3">
              <div>
                <Label>Senha atual</Label>
                <Input data-testid="change-current-password" type="password" value={current} onChange={(e) => setCurrent(e.target.value)} required className="mt-1" />
              </div>
              <div>
                <Label>Nova senha</Label>
                <Input data-testid="change-new-password" type="password" value={next} onChange={(e) => setNext(e.target.value)} required minLength={8} className="mt-1" />
              </div>
              <div>
                <Label>Confirmar nova senha</Label>
                <Input data-testid="change-confirm-password" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} className="mt-1" />
              </div>
              <Button data-testid="change-password-submit" type="submit" disabled={loading} className="w-full bg-[var(--g66-amber)] text-black hover:bg-[var(--g66-amber-2)]">
                {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Alterar senha'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
